import { Box, Container, Divider, Typography } from "@mui/material";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { ChildQuestionCard } from "../../commanComponents/ChildQuestionCard";
import { AddDependantText } from "../../commanComponents/AddDependantText";
import { PlusMinusButton } from "../../commanComponents/PlusMinusButton";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DependantQuestionCard } from "../../commanComponents/DependantQuestionCard";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { DataContext } from "../../Hooks/context/ChildData";
import { useLocalStorage } from "../../logic/LocalStorage/LocalStorage";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { childrenNames } from "../../constants/ChildrenPostfixArray";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const ChildQuestion = () => {
  const [childCards, setChildCards] = useState([0]);
  const [isDependantCard, setIsDependantCard] = useState(false);
  const [addQuestionCard, setAddQuestionCard] = useState([]);
  const [children, setChildren] = useState([{ name: "", age: "" }]);
  const [dependants, setDependants] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { collectData } = useContext(DataContext);
  const navigation = useNavigate();
  const { userId } = authTokens;
  const nameRegex = /^[A-Za-z\s]+$/;

  // Retrieve data from localStorage on mount
  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const data = await retrieveLocalFinancialData(`childnameage-${userId}`);
        if (data) {
          if (data.childCards) {
            const countArray = Array.from(
              { length: data.childCards },
              (_, i) => i
            );
            setChildCards(countArray);
          }

          if (data.children && Array.isArray(data.children)) {
            setChildren(data.children);
          } else {
            setChildren([{ name: "", age: "" }]);
          }

          if (
            data.dependants &&
            Array.isArray(data.dependants) &&
            data.dependants.length > 0
          ) {
            setDependants(data.dependants);
            setIsDependantCard(true);
            const dependantCards = Array.from(
              { length: data.dependants.length },
              (_, i) => i
            );
            setAddQuestionCard(dependantCards);
          } else {
          }
        }
      } catch (error) {}
    };

    retrieveSavedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddChildCard = () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioChildren, verifyData.customerId);
    setChildCards([...childCards, childCards.length]);
    setChildren([...children, { name: "", age: "" }]);
  };

  const handleRemoveChildCard = (index) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioChildren, verifyData.customerId);
    if (childCards.length >= 1) {
      setChildCards(childCards.slice(0, -1));
    }
    setChildren(children.filter((_, i) => i !== index));
  };
  //Hanlde Child according name or age
  const handleChildChange = (index, field, value) => {
    const updatedChildren = [...children];

    if (!updatedChildren[index]) {
      return;
    }

    // Handle name field
    if (field === "name") {
      // Allow empty string
      if (value === "") {
        updatedChildren[index][field] = "";
        setChildren(updatedChildren);
        return;
      }

      // Check name validation only for non-empty values
      if (!nameRegex.test(value)) {
        setSnackbarMessage(String.ChildPlannig.nameCannotEmpty);
        setSnackbarOpen(true);
        return;
      }

      // Apply capitalization for valid names
      updatedChildren[index][field] = value.replace(
        /^./,
        value[0].toUpperCase()
      );
    } else {
      // Handle other fields
      updatedChildren[index][field] = field === "age" ? Number(value) : value;
    }

    setChildren(updatedChildren);
  };

  //Handle dependant change name or age
  const handleDependantChange = (index, field, value) => {
    const updatedDependants = [...dependants];

    if (!updatedDependants[index]) {
      return;
    }

    // Handle name field
    if (field === "name") {
      if (value === "") {
        updatedDependants[index][field] = "";
        setDependants(updatedDependants);
        return;
      }
      if (!nameRegex.test(value)) {
        setSnackbarMessage(String.ChildPlannig.nameCannotEmpty);
        setSnackbarOpen(true);
        return;
      }
      updatedDependants[index][field] = value.replace(
        /^./,
        value[0].toUpperCase()
      );
    } else {
      updatedDependants[index][field] = field === "age" ? Number(value) : value;
    }

    setDependants(updatedDependants);
  };

  //on click for more dependant its adding card
  const handleAddDependantCard = () => {
    if (!isDependantCard) {
      setIsDependantCard(true);
      setAddQuestionCard([0]);
    }
    setAddQuestionCard([...addQuestionCard, addQuestionCard.length]); // Start with one dependant card

    setDependants([...dependants, { name: "", age: "" }]);
  };
  const handleRemoveDependantCard = (index) => {
    setAddQuestionCard(addQuestionCard.filter((_, i) => i !== index));
    setDependants(dependants.filter((_, i) => i !== index));
  };

  const handleContinue = () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioChildrenContinue, verifyData.customerId);
    const allChildrenFilled = children.every(
      (child) => child.name.trim() !== "" && child.age !== ""
    );
    const allDependantsFilled = isDependantCard
      ? dependants.every(
          (dependant) => dependant.name.trim() !== "" && dependant.age !== ""
        )
      : true;

    if (!allChildrenFilled || !allDependantsFilled) {
      setSnackbarMessage(
        String.ChildPlannig.validationMessageforchildanddependant
      );
      setSnackbarOpen(true);
      return;
    }

    let finalData;

    if (
      !dependants.every((dependant) =>
        Object.values(dependant).every((val) => val !== "")
      )
    ) {
      finalData = {
        children: children,
        dependants: [],
        childCards: childCards.length,
      };
    } else {
      finalData = {
        children: children,
        dependants: dependants,
        childCards: childCards.length,
      };
    }
    saveLocalFinancialData(`childnameage-${userId}`, finalData);
    collectData(finalData);
    navigation(String.navigations.childeducationmarriage);
  };

  //for postfix in question in name box
  const getChildName = (index) => {
    return childrenNames[index] || `${index + 1}th`;
  };
  return (
    <Box
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={String.ChildPlannig.Title} />
        <LinearProgressBar progress={40} progressNumber={40} stepNumber={2} />
        <Box sx={{ textAlign: "center", mt: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {String.ChildPlannig.question3}
          </Typography>
        </Box>

        {/* Center the PlusMinusButton */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <PlusMinusButton
            childCards={childCards.length}
            onClickAdd={handleAddChildCard}
            onClickRemove={() => {
              if (childCards.length > 1) {
                handleRemoveChildCard(children.length - 1);
              }
            }}
          />
        </Box>
        <Divider sx={{ mt: "30px", mb: "30px" }} />
        <Box sx={{ width: "100%", textAlign: "center" }}>
          {childCards.map((_, index) => (
            <ChildQuestionCard
              question={`What is your ${getChildName(index)} child’s age?`}
              placeholder={`Your ${getChildName(index)} child name`}
              childName={children[index]?.name || ""}
              totalAge={children[index]?.age || ""}
              isVisible={false}
              onRemoveClick={() => handleRemoveChildCard(index)}
              onChildNameChange={(value) =>
                handleChildChange(index, "name", value)
              }
              onAgeChange={(value) => handleChildChange(index, "age", value)}
            ></ChildQuestionCard>
          ))}

          {isDependantCard && (
            <>
              <Box sx={{ width: "100%", textAlign: "center" }}>
                {addQuestionCard.map((_, index) => (
                  <DependantQuestionCard
                    key={index}
                    question={`What is your ${getChildName(
                      index
                    )} dependant age?`}
                    placeholder={`Your ${getChildName(index)} dependant name`}
                    totalAge={dependants[index]?.age || ""}
                    isVisible={true}
                    depandantName={dependants[index].name}
                    onRemoveClick={() => {
                      handleRemoveDependantCard(index);
                    }}
                    onDependantNameChange={(value) => {
                      handleDependantChange(index, "name", value);
                    }}
                    onDepandantAgeChange={(value) => {
                      handleDependantChange(index, "age", value);
                    }}
                  ></DependantQuestionCard>
                ))}
              </Box>
            </>
          )}
          <AddDependantText
            onClickHandle={handleAddDependantCard}
          ></AddDependantText>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: "50px" }}>
          <ACRButton
            label={String.continue}
            style={{
              width: "100%",
              maxWidth: "350px",
              backgroundColor: getColor.ColorButtonPrimarysurface,
              color: getColor.PrimaryWhite,
              borderRadius: "40px",
              p: "10px",
              height: "60px",
              mb: "40px",
              lineHeight: "22.2px",
              fontWeight: 700,
              fontSize: "16px",
              textAlign: "center",
              textTransform: "initial",
            }}
            onClickButton={handleContinue}
          />
        </Box>
      </Container>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={String.ErrorSeverity}
        handleClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};

export default ChildQuestion;
